'use strict';

import baseConfig from './base';
import { version } from './version';

let config = {
  version: version,
  guest_token: '1kQrjzlIY3AIpv83iWJ7Dv53vNECKWAM0vDVllnXSi3u8I22tuod4Rh1FNE5T5L0DjvNvurxoos8j9NnRYTeRS8tx2GIxlE3XfGBLdl5v23gdlsV9847yYj2vPolm9Os',
  stripe_keys: {
    toronto: 'pk_live_piH50bk7ujXQrWfJtzKS5BCa',
    rimisecureadvantageplus: 'pk_live_51T7HjBE3dmn5hjf95iGyKE29ejNhphRfNdWdZawGBNt4yfT8uLvfxXBKegy4TZ0WP0eC6XGADDsLnT6CyQo3r6ga00foCt1Fcr',
  },
  api: 'https://auth.policy-dashboard.com/api/travel/insurance',
  headers: { Accept: 'application/vnd.ingle+json; version=1' },
  auth_base_api: 'https://auth.policy-dashboard.com',
  agent_portal: 'http://www.mshagents.com',
  microsite_url: 'http://www.mshgroups.com',
  dashboard_url: 'https://studyinsured.policy-dashboard.com',
  magenta_login: 'https://studyinsuredportal.ca/a/dashboardlogin',
  PPN_google_analytics_measurement_id: 'G-1W21RB5BET',
  MEMBER_PORTAL_LANDING_PAGE_GA_measurement_id: {
    pshcp:'G-W1EDLGBNBX',
    rssfp:'G-Q1PGRMLQHS'
  },
  microsite_google_analytics_measurement_id: 'G-WHKCZ6Q3MF',
  email: {
    policyConfirmation: {
      cc: [],
    }
  },
  ingle: {
    form_base_url: 'https://msh-forms.policy-dashboard.com',
  },
  rimi: {
    form_base_url: 'https://rimi-forms.policy-dashboard.com',
  },
  msg: {
    form_base_url: 'https://msg-forms.policy-dashboard.com',
  },
  visitcanada: {
    form_base_url: 'https://2visitcanada-forms.policy-dashboard.com',
  },
  insurecanada: {
    form_base_url: 'https://insurecanada-forms.policy-dashboard.com',
  },
  alumo: {
    form_base_url: 'https://alumo-forms.policy-dashboard.com',
  },
  mapslyIds: {
    'default': {
      'en': '62b0f5ecbbbd4e538c1ae97b7e296c2d',
      'fr': '7dcdd18ec297464c9f46cfd5e666629f'
    },
    'alumo': {
      'en': '1ae7cda45c444816bee2716acbc37654',
      'fr': 'c7b89633bbe94a95afc63ef47d86d2cf'
    }
  }
};

export default Object.freeze(Object.assign({}, new baseConfig, config));




// WEBPACK FOOTER //
// ./src/config/prod.js